module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard-main"
  }, [_c('div', {
    staticClass: "columns is-multiline is-centered"
  }, [(_vm.checkVisibility('expense', 'view')) ? _c('reminders') : _vm._e(), (_vm.checkVisibility('expense', 'view')) ? _c('expenses-due') : _vm._e(), (_vm.checkVisibility('expense', 'view')) ? _c('expenses-waiting') : _vm._e(), (_vm.checkVisibility('expense', 'view')) ? _c('expenses-advance') : _vm._e(), (_vm.checkVisibility('revenue', 'view')) ? _c('revenues-due') : _vm._e(), (_vm.checkVisibility('revenue', 'view')) ? _c('revenues-waiting') : _vm._e(), (_vm.checkVisibility('yield', 'view')) ? _c('yields-due') : _vm._e(), (!_vm.checkVisibility('expense', 'view') && !_vm.checkVisibility('revenue', 'view')) ? _c('div', {
    staticClass: "column is-11"
  }, [_vm._m(0)]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Bem-vindo!")]), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("ao ERP - THEPES!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3489d77f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/Dashboard.vue
// module id = 396
// module chunks = 56